module.exports = __webpack_public_path__ + "static/media/phone.7a702f4c.svg";